import { render, staticRenderFns } from "./SetoresEdit.vue?vue&type=template&id=2cf90174"
import script from "./SetoresEdit.vue?vue&type=script&lang=js"
export * from "./SetoresEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports